/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const autocompleteAddressQueryParams = zod.object({
  "input": zod.string(),
  "sessionToken": zod.string(),
  "latitude": zod.number().optional(),
  "longitude": zod.number().optional()
})

export const autocompleteAddressResponse = zod.object({
  "suggestions": zod.array(zod.object({
  "placeId": zod.string(),
  "description": zod.string(),
  "mainText": zod.string(),
  "secondaryText": zod.string()
}))
})

export const getAddressDetailsParams = zod.object({
  "placeId": zod.string()
})

export const getAddressDetailsQueryParams = zod.object({
  "sessionToken": zod.string().optional()
})

export const getAddressDetailsResponseAddressLine1Max = 255;

export const getAddressDetailsResponseAddressLine2Max = 255;

export const getAddressDetailsResponseCityMax = 255;

export const getAddressDetailsResponseStateMax = 2;

export const getAddressDetailsResponseZipMax = 10;

export const getAddressDetailsResponseCountryMax = 100;



export const getAddressDetailsResponse = zod.object({
  "addressLine1": zod.string().max(getAddressDetailsResponseAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getAddressDetailsResponseAddressLine2Max).nullish(),
  "city": zod.string().max(getAddressDetailsResponseCityMax).nullish(),
  "state": zod.string().max(getAddressDetailsResponseStateMax).nullish(),
  "zip": zod.string().max(getAddressDetailsResponseZipMax).nullish(),
  "country": zod.string().max(getAddressDetailsResponseCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
})

